export const buyingProccess = {
    redbtn: 'ثبت خرید',
    continuebtn:'ادامه فرآیند خرید',
    continuebtnlogin:'ورود / ثبت نام',
    continuebtnuserdata:'تکمیل حساب و ادامه',
    payableGift:'اعتبار هدیه',
    payable:'قابل پرداخت',
    off:'تخفیف کالا',
    tool:'عوارض',
    tax:'ارزش افزوده',
    price:'مبلغ',
    delete:'حذف',
    back:'مرحله قبل',
    cancel:'لغو',
    toman:'تومان',
    free:'رایگان',
    basketDetail: ' سبد خرید شما',
    totalOrders:'فاکتور خرید',
    totalBasket:'قیمت خرید شما',
    delivery:'هزینه ارسال',
    deliveryText:'در صورت تغییر آدرس، هزینه ارسال جدید محاسبه و اعمال خواهد شد.',
    reservedText:'کالا های موجود در سبد شما ثبت و رزرو نشده اند برای ثبت ســــــفارش مراحــل بعدی را تکمــــیل کنید.',
    like:'ذخیره در لیست علاقه مندی ها',
    address:'برای ادامه فرآیند خرید، آدرس مورد نظر خود را تعیین نمایید',
    addressbtn:'تایید آدرس و ادامه',
    recipient:'تحویل گیرنده خودم هستم',
    emrphone:'شماره تماس ضروری',
    selectadd:'انتخاب آدرس',
    changeadd:'ویرایش آدرس',
    chooseAddress:'لطفا آدرس خود را انتخاب کنید',
    searchAdd:'جستجو شهر، محله و آدرس',
    selectedAddress:'ادرس های منتخب',
    addressAlert:'(برای ویرایش آدرس ها به پنل کاربری مراجعه فرمایید)',
    newAddress:'افزودن آدرس جدید',
    newAddressalert:' آدرس انتخاب نشده است',
    payway:'انتخاب روش پرداخت',
    rule:'شرایط و قوانین وبسایت را قبول دارم',
    pay:'پرداخت',
    payed:'پرداخت شد',
    cancelpayed:'لغو پرداخت ',
    empty:'سبد خرید شما خالی است',
    basketError:'این کالا در سبد موجود است. برای تغییر تعداد به صفحه سبد خرید مراجعه کنید',
    errorLogin:'برای استفاده از سبد خرید ورود کنید \n پروفایل->ورود',
    deletegood:'از حذف کالا مطمئن هستید؟',
    addbasket:'محصول اضافه شد',
    removebasket:'محصول کم شد',
    deleteerro:'مشکلی در حذف کردن محصول وجود دارد',
    deletegooderr:'محصول حذف شد'
}